import type React from 'react';

import { Image } from '@change/ds-core-ui';

import type { Template } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { PosterPreviewLoading } from '../PosterPreviewLoading';

type PosterPreviewProps = {
	posterTemplate?: {
		name: string;
		images: Template['images'];
	};
};

export const PosterPreview: React.FC<PosterPreviewProps> = ({ posterTemplate }) => {
	if (!posterTemplate) {
		return <PosterPreviewLoading />;
	}

	return (
		<div>
			<Image
				className="h-[175px] w-[131px] rounded-lg"
				src={posterTemplate.images.png.src}
				srcSet={posterTemplate.images.png.srcset}
				alt={posterTemplate.name}
				sx={{
					aspectRatio: '180/233',
				}}
			/>
		</div>
	);
};
